import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import JsxHelper from "../Helpers/JsxHelper";
import LookupItemText from "../Elements/LookupItemText";

export default class OfficeEmployeeCostGroupSettingItem
{
    constructor (item)
    {
        if (item === undefined)
        {
            this.Id = "";
            this.OfficeId = "";
            this.CostGroupLookupItemId = "";
            this.Description = "";
            this.IsIncludedInWeeklyUpdate = false;
        } else
        {
            this.Id = item.id;
            this.OfficeId = item.officeId;
            this.CostGroupLookupItemId = item.costGroupLookupItemId;
            this.Description = item.description;
            this.IsIncludedInWeeklyUpdate = item.isIncludedInWeeklyUpdate;
        }
    }

    static FieldsToShowInDataTable ()
    {
        return [
            { label: "Cost Group", orderById: "", data: (item) => <LookupItemText lookupId={68} lookupItemId={item.CostGroupLookupItemId} /> },
            { label: "Description", orderById: "", data: (item) => item.Description },
            { label: "Included In Weekly Update", orderById: "", data: (item) => JsxHelper.YesNo(item.IsIncludedInWeeklyUpdate) },
            { label: " ", orderById: "", data: OfficeEmployeeCostGroupSettingItem.getActionCellContent, type: FieldTypesEnum.ActionButton },
        ];
    }

    static clickOnEdit = () => { };

    toRawObject ()
    {
        return {
            id: this.Id,
            officeId: this.OfficeId,
            costGroupLookupItemId: this.CostGroupLookupItemId,
            description: this.Description,
            isIncludedInWeeklyUpdate: this.IsIncludedInWeeklyUpdate,
        };
    }

    static getActionCellContent (item)
    {
        return (
            <DataTableActionMenu
                options={[
                    {
                        text: "Edit",
                        onClick: () => OfficeEmployeeCostGroupSettingItem.clickOnEdit(item.toRawObject()),
                        iconName: "fa-solid fa-edit",
                        roleKey: "home_offices_edit",
                    },
                ]}
            />
        );
    }
}
